export default "__VITE_ASSET__DsKfzyty__"